import axios from 'axios'
import router from '@/router'
import Vue from 'vue';
import { Toast,Indicator} from 'mint-ui'


const http = axios.create({
    baseURL:window.configUrl,
    timeout: 1000 * 30,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  var token=sessionStorage.getItem('token');
  // if(token){
  //    config.headers['token'] = token;
  // }

    return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
    // if (response.data.code && response.data.code == "0000") {
    //       Toast(response.data.message);
    // }
    return response
}, error => {
    Indicator.close();
    if (error.response && error.response.status) {
        Toast(error.response.data.message);
    }else{
        Toast("系统错误，联系管理员");
    }
    return Promise.reject(error)
})
export default http



// WEBPACK FOOTER //
// ./src/common/http.js